<template>
  <!-- eslint-disable vue/no-unused-refs MIXIN -->
  <div class="bx-content">
    <h2 v-if="headline"
        class="bx-typo--h2">
      {{ headline }}
    </h2>
    <div id="channel-slider-flickity-0"
         ref="flickityDiv"
         class="bx-slider bx-slider--channel-slider">
      <div v-for="(channel, index) in channels"
           :id="`bx-js-channel-slider-cell-${index}`"
           :key="index"
           class="bx-slider__cell">
        <a class="bx-epg-channel"
           :href="channel.url"
           :title="channel.name"
           tabindex="-1">
          <figure>
            <img :src="channelLogoSrc(channel.logo)"
                 :alt="`${channel.logo.imageAltText} Logo`"
                 :title="channel.logo.imageAltText"
                 :width="channel.logo.width"
                 :height="channel.logo.height"
                 loading="lazy">
          </figure>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

import { useConfigStore } from '../../stores/config'
import { usePageStore } from '../../stores/page'
import imgSrcSet from '../../mixins/img-src-set'
import flickitySlider from '../../mixins/flickity-slider'

export default {
  name: 'ChannelSlider',
  mixins: [imgSrcSet, flickitySlider],
  props: {
    headline: {
      type: String,
      default: null
    },
    channels: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data () {
    return {
      customSliderOptions: {
        friction: 0.5
      }
    }
  },
  computed: {
    ...mapState(useConfigStore, ['rsConfig']), // this store prop is used by the `imgSrcSet` mixin
    ...mapState(usePageStore, ['viewportMetaModified', 'pageData', 'brandFromStore'])
  },
  async mounted () {
    await this.initFlickitySlider(this.customSliderOptions)
  },
  methods: {
    channelLogoSrc (logo) {
      return logo.imageId
        ? this.createImgSrc({
          image: logo,
          brand: this.brandFromStore,
          type: 'webp',
          setName: 'channelLogo'
        })
        : null
    }
  }
}
</script>
